import React from 'react';
import { useApiError } from '../context/ApiErrorContext';

const ErrorAlert: React.FC = () => {
  const { error, clearError } = useApiError();

  if (!error) return null;

  // Blindagem: `error` deveria ser string, mas se algum chamador passar um objeto
  // (ex.: um ApolloError), renderizá-lo direto quebraria o React ("Objects are not
  // valid as a React child") e derrubaria a tela. Normaliza para texto sempre.
  const mensagem =
    typeof error === 'string'
      ? error
      : ((error as any)?.message ?? 'Ocorreu um erro inesperado.');

  return (
    <div 
      className="alert alert-danger alert-dismissible fade show" 
      role="alert"
      style={{ position: 'fixed', top: '10%', right: '10px', zIndex: 1050 }}
      >
      {mensagem}
      <button type="button" className="btn-close" aria-label="Close" onClick={clearError}></button>
    </div>
  );
};

export default ErrorAlert;
